import { useMemo } from 'react';

import agentProfilesResource from 'src/actions/agent/agentProfilesResource';
import teamsResource, { Team } from 'src/actions/teams/teamsResource';
import useResource, { allSucceeded, getConsolidatedState, isLoadingStatus } from 'src/presentation/hooks/useResource';
import { DomainError } from '@ad-scripts/application/lib/error';

type ResultType = { isLoading: boolean; teamsList: Team[]; resetErrors: () => void; errors: DomainError[] };

export default function useTeams(): ResultType {
  const { resetErrors } = teamsResource.actions as any;
  const {
    values: teams,
    loadingState: teamsLoadingState,
    errors,
  }: { values: Team[]; loadingState: string; errors: DomainError[] } = useResource(teamsResource);

  const { values: agentsList, loadingState: agentsLoadingState } = useResource(agentProfilesResource);

  const teamsList = useMemo<Team[]>(() => {
    if (!allSucceeded(teamsLoadingState, agentsLoadingState)) {
      return [];
    }

    const teamsList = teams.map(({ agentIds, description, ...team }) => ({
      ...team,
      agentIds,
      agentsList,
      description: description || '',
      memberCount: agentIds?.length || 0,
    }));

    return teamsList;
  }, [teams, agentsList, teamsLoadingState, agentsLoadingState]);

  const isLoading = isLoadingStatus(getConsolidatedState([teamsLoadingState]));
  return { isLoading, teamsList, resetErrors, errors };
}
